// это компонент высшего порядка
import { useLocation, Navigate } from "react-router-dom";
import useLogin from "../../hooks/useLogin";

const RequireAuth = ({ children }) => {
    const location = useLocation();
    const user = sessionStorage.getItem('user');
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} />;
    }

    return children;
};

export default RequireAuth;
